module.exports = __webpack_public_path__ + "static/img/iconmonstr-phone-hang.a2b51b65.svg";